import React from "react";
import GameList from "./GameList";

export default function LobbyMid() {
    return(
        <div style={{width: '450px', height: '368px', textAlign: 'center'}}>
            <img alt="duckrace" src="duckrace-banner.png" style={{width: '300px', paddingBottom: '5px'}}/>
            <GameList/>
        </div>
    );
}
